import React, { Suspense, lazy, useEffect, useRef, useState } from 'react'
import { Spin } from 'antd'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Mousewheel, Pagination } from 'swiper/modules'
import type SwiperCore from 'swiper'

import { IStructure, Portal } from 'src/interfaces/structure'

import { useListBrands, useObtainStructure } from 'src/api/graphql'

import IndexV2 from 'src/layouts/Navbar/indexV2'

import 'swiper/css'
import 'swiper/css/pagination'
import { Slider } from '../components/Slider'

/*import Footer from 'src/layouts/Footer'
import { Metrics } from '../components/Metrics'
import ValueProposition from '../components/ValueProposition'
import CategorySlider from '../components/Category'
import PartnersSlider from '../components/Clients'
import BrandSlider from '../components/Brands'
import QuoteSteps from '../components/QuoteSteps'
import HistoricWorksSlider from '../components/HistoricWorksSlider'*/

import './styles.css'

const Footer = lazy(() => import('src/layouts/Footer'))
// const Slider = lazy(() =>
//   import('../components/Slider').then((module) => ({ default: module.Slider }))
// )
const Metrics = lazy(() =>
  import('../components/Metrics').then((module) => ({ default: module.Metrics }))
)
const ValueProposition = lazy(() => import('../components/ValueProposition'))
const CategorySlider = lazy(() => import('../components/Category'))
const PartnersSlider = lazy(() => import('../components/Clients'))
const BrandSlider = lazy(() => import('../components/Brands'))
const QuoteSteps = lazy(() => import('../components/QuoteSteps'))
const HistoricWorksSlider = lazy(() => import('../components/HistoricWorksSlider'))
const Testimony = lazy(() => import('src/pages/Aboutus/components/Testimony'))
const FeatureProducts = lazy(() => import('src/pages/HomeV2/components/FeaturedProducts'))

const HomePageV2 = () => {
  const [structure, setStructure] = useState<IStructure | null>(null)
  const [isVisible, setVisible] = useState<boolean>(false)
  const qStructure = useObtainStructure({ portal: Portal.store })
  const swiperRef = useRef<SwiperCore>()
  const { data } = useListBrands()
  const brands = data?.listSpecificBrands || []

  useEffect(() => {
    if (!qStructure.loading && qStructure.data) {
      setStructure(qStructure.data?.obtainStructure)
    }
  }, [qStructure.loading, qStructure.data])

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset
      const screenHeight = window.innerHeight
      console.log(scrollY, screenHeight)
      setVisible(scrollY > screenHeight)
    }
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <>
      <Swiper
        direction={'vertical'}
        slidesPerView={1}
        spaceBetween={30}
        mousewheel={true}
        modules={[Mousewheel, Pagination]}
        pagination={{
          clickable: true,
        }}
        className="mySwiper"
        onSwiper={(swiper: any) => {
          swiperRef.current = swiper
        }}
        onSlideChange={(val: any) => {
          setVisible(val.activeIndex > 0)
        }}
      >
        <SwiperSlide>
          <Slider images={structure?.bannersV2} swiperInstance={swiperRef.current} />
        </SwiperSlide>

        {isVisible && <IndexV2 />}

        <Suspense fallback={<Spin />}>
          <SwiperSlide>
            <QuoteSteps></QuoteSteps>
          </SwiperSlide>
        </Suspense>
        <Suspense fallback={<Spin />}>
          <SwiperSlide>
            <CategorySlider></CategorySlider>
          </SwiperSlide>
        </Suspense>
        <Suspense fallback={<Spin />}>
          <SwiperSlide>
            <FeatureProducts></FeatureProducts>
          </SwiperSlide>
        </Suspense>
        <Suspense fallback={<Spin />}>
          <SwiperSlide>
            <BrandSlider listSpecificBrands={brands}></BrandSlider>
          </SwiperSlide>
        </Suspense>
        <Suspense fallback={<Spin />}>
          <SwiperSlide>
            <ValueProposition></ValueProposition>
          </SwiperSlide>
        </Suspense>
        <Suspense fallback={<Spin />}>
          <SwiperSlide>
            <PartnersSlider></PartnersSlider>
          </SwiperSlide>
        </Suspense>
        <Suspense fallback={<Spin />}>
          <SwiperSlide>
            <HistoricWorksSlider></HistoricWorksSlider>
          </SwiperSlide>
        </Suspense>
        <Suspense fallback={<Spin />}>
          <SwiperSlide>
            <Testimony />
          </SwiperSlide>
        </Suspense>
        <Suspense fallback={<Spin />}>
          <SwiperSlide>
            <Metrics></Metrics>
          </SwiperSlide>
        </Suspense>
        <Suspense fallback={<Spin />}>
          <SwiperSlide
            style={{
              display: 'flex',
              justifyContent: 'center',
              backgroundColor: '#030852',
            }}
          >
            <Footer />
          </SwiperSlide>
        </Suspense>
      </Swiper>
    </>
  )
}
export default HomePageV2
